import type { IconFieldDesignTokens } from '@primeuix/themes/aura/iconfield';

export default {
  icon: {
    color: '{form.field.icon.color}',
  },
} satisfies IconFieldDesignTokens;
